import { apiPost } from '../../utils/api';

export const passwordResetCall = (email) => {
  return apiPost('/request_password_reset', null, { email });
};
